module.exports = __webpack_public_path__ + "media/audio2.b74649df.wav";